import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, ref } from 'vue';
import { ProductFilters } from '@/api/typings/podProviders';
import vSelect from 'vue-select';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariantFilters',
  props: {
    filters: null,
    disableActions: { type: Boolean },
    allowMultipleSelect: { type: Boolean, default: true }
  },
  emits: ['search'],
  setup(__props: any, { emit }) {

const props = __props as { filters: ProductFilters[], disableActions?: boolean, allowMultipleSelect: boolean };





const filtersVisible = ref(false);
const addedFilters: Ref<any[]> = ref([]);

const isSearchDisabled = computed(() => {
    return props.disableActions || addedFilters.value.every((filter) => filter.selectedValues?.length == 0);
});

const addFilter = () => {
    addedFilters.value.push({
        selectedFilter: null,
        selectedValues: []
    });
};

const search = () => {
    const params: { [key: string]: string[] } = {};

    for (const filter of addedFilters.value) {
        if (!filter.selectedValues?.length || !filter.selectedFilter?.id) return;
        params[filter.selectedFilter.id] = Array.isArray(filter.selectedValues)
            ? [...filter.selectedValues]
            : [filter.selectedValues];
    }

    emit('search', params);
};

const clearFilter = () => {
    addedFilters.value = [];
    emit('search');
};

const onFilterTypeDeselected = (filter: any) => {
    filter.selectedValues = [];
};

const toggleFilters = () => {
    filtersVisible.value = !filtersVisible.value;
};

return { __sfc: true,emit, props, filtersVisible, addedFilters, isSearchDisabled, addFilter, search, clearFilter, onFilterTypeDeselected, toggleFilters, vSelect }
}

})